const CLOSE_AMATEUR_FILM = 'CLOSE_AMATEUR_FILM';

const AMATEUR_FILM_LOAD_REQUEST = 'AMATEUR_FILM_LOAD_REQUEST';
const AMATEUR_FILM_LOAD_SUCCESS = 'AMATEUR_FILM_LOAD_SUCCESS';
const AMATEUR_FILM_LOAD_ERROR = 'AMATEUR_FILM_LOAD_ERROR';

const AMATEUR_FILM_LIKE_REQUEST = 'AMATEUR_FILM_LIKE_REQUEST';
const AMATEUR_FILM_LIKE_SUCCESS = 'AMATEUR_FILM_LIKE_SUCCESS';
const AMATEUR_FILM_LIKE_ERROR = 'AMATEUR_FILM_LIKE_ERROR';

const AMATEUR_FILM_INCREMENT_VIEWS_REQUEST = 'AMATEUR_FILM_INCREMENT_VIEWS_REQUEST';
const AMATEUR_FILM_INCREMENT_VIEWS_SUCCESS = 'AMATEUR_FILM_INCREMENT_VIEWS_SUCCESS';
const AMATEUR_FILM_INCREMENT_VIEWS_ERROR = 'AMATEUR_FILM_INCREMENT_VIEWS_ERROR';

const AMATEUR_FILM_COMMENT_REQUEST = 'AMATEUR_FILM_COMMENT_REQUEST';
const AMATEUR_FILM_COMMENT_SUCCESS = 'AMATEUR_FILM_COMMENT_SUCCESS';
const AMATEUR_FILM_COMMENT_ERROR = 'AMATEUR_FILM_COMMENT_ERROR';

import * as backend from 'backend-helpers/amateurFilm';

function sortComments(c1, c2) {
    return c1.id > c2.id ? -1 : 1;
}

export default function amateurFilm(state = {}, action) {
    switch (action.type) {
        case AMATEUR_FILM_LOAD_REQUEST:
            return {
                ...action.amateurFilm,
                isLoading: true
            };

        case AMATEUR_FILM_LOAD_SUCCESS:
            const {amateurFilm} = action.result.data;
            amateurFilm.comments.sort(sortComments);

            return {
                ...amateurFilm,
                isLoading: false
            };

        case AMATEUR_FILM_LIKE_SUCCESS:
            return {
                ...state,
                is_liked: true,
                like_count: action.result.like_count
            };

        case AMATEUR_FILM_COMMENT_SUCCESS:
            return {
                ...state,
                comments: [...state.comments, action.result.data.comment].sort(sortComments)
            };

        case AMATEUR_FILM_INCREMENT_VIEWS_SUCCESS:
            return {
                ...state,
                views: action.result.data.views
            };

        case CLOSE_AMATEUR_FILM:
            return initState;

        default:
            return state;
    }
}


export function openAmateurFilm(params) {
    return {
        types: [AMATEUR_FILM_LOAD_REQUEST, AMATEUR_FILM_LOAD_SUCCESS, AMATEUR_FILM_LOAD_ERROR],
        promise: backend.getAmateurFilm(params),
        amateurFilm
    }
}

export function closeAmateurFilm() {
    return {
        type: CLOSE_AMATEUR_FILM
    }
}

export function likeAmateurFilm({id}) {
    return {
        types: [AMATEUR_FILM_LIKE_REQUEST, AMATEUR_FILM_LIKE_SUCCESS, AMATEUR_FILM_LIKE_ERROR],
        promise: backend.likeAmateurFilm({id}),
        id
    }
}

export function incrementAmateurFilmViews(id) {
    return {
        types: [AMATEUR_FILM_INCREMENT_VIEWS_REQUEST, AMATEUR_FILM_INCREMENT_VIEWS_SUCCESS, AMATEUR_FILM_INCREMENT_VIEWS_ERROR],
        promise: backend.incrementAmateurFilmViews(id),
        id
    }
}

export { AMATEUR_FILM_LIKE_SUCCESS, AMATEUR_FILM_COMMENT_SUCCESS };



// WEBPACK FOOTER //
// ./src/reducers/amateurFilm.js